import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents } from 'presto-mini-apps-lib';
import {
    ContainerHeight,
    ContainerOffsetTop,
    ContainerWidth,
    HeaderHeight,
    ButtonHeight,
    RedirectDelay,
    getPaymentRefNum
} from '../../constants/appState';
import Header from '../Header';
import Preloader from '../Preloader';
import { connect } from 'react-redux';
import MessagePanel from '../MessagePanel';
import { 
    ErrorMessages, 
    phrase_CancelTransactionAndReturn,
    phrase_VerifyingPayment,
    phrase_return, 
    term_return, 
} from '../../constants/text';
import { appService } from '../../services';
import { 
    setStopQueryPolling, 
    setCurPageIsError, 
    userTriggeredLeave 
} from '../../actions';
import { PaymentStatus } from '../../constants/statusCode';
import Loader from '../Loader';
import PoweredByPresto from '../PoweredByPresto';


class PageWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            qrRegistered: false,

            sessionEnded: false,
            maxLoginTriesReached: false,
            max2FATriesReached: false,
            maxResendOTPReached: false,
            queryFailed: false,
            defaultError: false,
            // isLoading: false,
            isVerifying: false,
            
            paymentError: false,
            paymentErrorType: '',
        }
    }

    componentDidUpdate(prevProps) {
        const { appState } = this.props;
        
        if(prevProps.appState.listenerData.qrRegistered !== appState.listenerData.qrRegistered) {
            if(!!appState.listenerData.qrRegistered) {
                this.setState({ qrRegistered: true });
            }
        }

        if(prevProps.appState.isVerifying !== appState.isVerifying) {
            // if(!!appState.isVerifying) {
                this.setState({ isVerifying: appState.isVerifying });
            // }
        }
        
        if(prevProps.appState.listenerData.sessionEnded !== appState.listenerData.sessionEnded) {
            if(!!appState.listenerData.sessionEnded) {
                this.setState({ sessionEnded: true },
                    () => this.cancelTransaction('Session ended')
                );
            }
        }
        
        if(prevProps.appState.listenerData.maxLoginTriesReached !== appState.listenerData.maxLoginTriesReached) {
            if(!!appState.listenerData.maxLoginTriesReached) {
                this.setState({ maxLoginTriesReached: true },
                    () => this.cancelTransaction('Maximum login tries reached')
                );
            }
        }
        
        if(prevProps.appState.listenerData.max2FATriesReached !== appState.listenerData.max2FATriesReached) {
            if(!!appState.listenerData.max2FATriesReached) {
                this.setState({ max2FATriesReached: true },
                    () => this.cancelTransaction('Maximum 2FA tries reached')
                );
            }
        }
        
        if(prevProps.appState.maxResendOTPReached !== appState.maxResendOTPReached) {
            if(!!appState.maxResendOTPReached) {
                this.setState({ maxResendOTPReached: true },
                    () => this.cancelTransaction('Maximum OTP resend reached')
                );
            }
        }
        
        if(prevProps.appState.listenerData.queryFailed !== appState.listenerData.queryFailed) {
            if(!!appState.listenerData.queryFailed) {
                this.setState({ queryFailed: true },
                    () => this.cancelTransaction('Query failed')
                );
            }
        }
        
        if(prevProps.appState.paymentError !== appState.paymentError) {
            if(!!appState.paymentError) {
                this.setState({ 
                    paymentError: true,
                    paymentErrorType: appState.paymentErrorType
                }, () => this.cancelTransaction('Payment error')
                );
            }
        }

        if(prevProps.appState.isDefaultError !== appState.isDefaultError) {
            if(!!appState.isDefaultError) {
                this.setState({ defaultError: true },
                    () => this.cancelTransaction('Other errors')
                );
            }
        }
    }

    onCancelTransactionSuccessHandler = (resp) => {
        console.log('onCancelTransactionSuccessHandler', resp);
        // NOTE: do nothing and query API handle page transition 

    };

    onCancelTransactionFailedHandler = (data) => {
        console.log('onCancelTransactionFailedHandler', data);
        // NOTE: if cancel failed, do nothing and let back-end expires the transaction

    };

    cancelTransaction = (n) => {
        console.log('Transaction cancelled:', n);
        const { 
            appState, 
            setStopQueryPolling, 
            setCurPageIsError,
        } = this.props;

        if(appState.listenerData.paymentStatus === PaymentStatus.PENDING_AUTHORISE) {
            appService.apiCancelPayment({
                paymentRefNum: getPaymentRefNum(),
                paymentCode: window.PrestoPayObj.paymentCode,
                onSuccess: this.onCancelTransactionSuccessHandler,
                onError: this.onCancelTransactionFailedHandler,
            });
        }

        setStopQueryPolling(true);
        setCurPageIsError(true);

        setTimeout(() => { 
            if(this.isMessage()) {
                setTimeout(() => this.goBack(), RedirectDelay);
            }
        }, 0);
    };

    immediateCancelTransaction = () => {
        const { 
            appState,
            setStopQueryPolling,
            userTriggeredLeave,
        } = this.props;

        userTriggeredLeave(true);
        setStopQueryPolling(true); 

        if(appState.listenerData.paymentStatus === PaymentStatus.PENDING_AUTHORISE) {
            appService.apiCancelPayment({
                paymentRefNum: getPaymentRefNum(),
                paymentCode: window.PrestoPayObj.paymentCode,
                onSuccess: (resp) => {
                    this.onCancelTransactionSuccessHandler(resp);
                    this.goBack();
                },
                onError: (data) => {
                    this.onCancelTransactionFailedHandler(data);
                    this.goBack();
                },
            });
        }
        // this.goBack();
    }

    goBack = () => {
        const { appState } = this.props;
        if(appState.listenerData.redirectUrl !== '') {
            window.location = appState.listenerData.redirectUrl;
        }
    };

    isMessage = () => {
        const {
            sessionEnded,
            maxLoginTriesReached,
            max2FATriesReached,
            maxResendOTPReached,
            paymentError,
            queryFailed,
            defaultError,
        } = this.state;

        return (sessionEnded ||
            maxLoginTriesReached ||
            max2FATriesReached ||
            maxResendOTPReached ||
            queryFailed ||
            paymentError ||
            defaultError
        );
    };

    render() {
        const { 
            appState, 
            showRedirectLink, 
            showPoweredByPresto,
            containerHeight,
            withBackButton,
        } = this.props;
        const {
            qrRegistered,
            sessionEnded,
            maxLoginTriesReached,
            max2FATriesReached,
            maxResendOTPReached,
            paymentError,
            paymentErrorType,
            queryFailed,
            defaultError,
            isVerifying,
        } = this.state;

        return (
            <React.Fragment>
                {window.PrestoPayObj && window.PrestoPayObj.logoUrl && (
                    <LogoArea className="logo-area">
                        <div className="logo-holder">
                            <div className="logo" style={{ backgroundImage: `url(${window.PrestoPayObj.logoUrl})`}} />
                        </div>
                    </LogoArea>
                )}
                <Header withBackButton={withBackButton} onBackClick={this.immediateCancelTransaction}/>
                <Container containerHeight={containerHeight} className={[
                    'page-wrapper',
                    (this.isMessage() ? ' is-message' : '')
                ].join('')}>
                    { (!!qrRegistered && !paymentError) && (
                        <Preloader  
                            title={ErrorMessages.QRRegistered.title}
                            message={ErrorMessages.QRRegistered.message}
                        />
                    )}

                    { (!!isVerifying) && (
                        <Preloader  
                            title={phrase_VerifyingPayment}
                            message={''}
                        />
                    )}

                    { !!sessionEnded && (
                        <MessagePanel 
                            title={ErrorMessages.SessionEnded.title}
                            message={ErrorMessages.SessionEnded.message}
                            isError
                        />
                    )}

                    { !!maxLoginTriesReached && (
                        <MessagePanel 
                            title={ErrorMessages.MaxLoginTriesReached.title}
                            message={ErrorMessages.MaxLoginTriesReached.message}
                            isError
                        />
                    )}

                    { !!max2FATriesReached && (
                        <MessagePanel 
                            title={(appState.listenerData.is2FAviaOTP 
                                ? ErrorMessages.Max2FAOTPTriesReached.title
                                : ErrorMessages.Max2FAPinTriesReached.title
                            )}
                            message={(appState.listenerData.is2FAviaOTP 
                                ? ErrorMessages.Max2FAOTPTriesReached.message
                                : ErrorMessages.Max2FAPinTriesReached.message
                            )}
                            isError
                        />
                    )}

                    { !!paymentError && (
                        <MessagePanel 
                            title={ErrorMessages[paymentErrorType].title}
                            message={ErrorMessages[paymentErrorType].message}
                            isError
                        />
                    )}

                    { !!maxResendOTPReached && (
                        <MessagePanel 
                            title={ErrorMessages.MaxResendOTPReached.title}
                            message={ErrorMessages.MaxResendOTPReached.message}
                            isError
                        />
                    )}

                    { (!!queryFailed || !!defaultError) && (
                        <MessagePanel 
                            title={(!!appState.defaultErrorData && appState.defaultErrorData.title !== '') 
                                ? appState.defaultErrorData.title
                                : ErrorMessages.DefaultError.title
                            }
                            message={(!!appState.defaultErrorData && appState.defaultErrorData.message !== '') 
                                ? appState.defaultErrorData.message
                                : ErrorMessages.DefaultError.message
                            }
                            isError
                        />
                    )}
                    
                    { (!qrRegistered && 
                        !sessionEnded &&
                        !maxLoginTriesReached &&
                        !max2FATriesReached &&
                        !maxResendOTPReached &&
                        !queryFailed &&
                        !paymentError &&
                        // !isVerifying &&
                        !defaultError
                    ) && (
                        <React.Fragment>
                            { this.props.children }
                        </React.Fragment>
                    )}
                    
                    { this.isMessage() && (
                        appState.listenerData.redirectUrl !== '' ? (
                            <div className="action-area">
                                <PrestoAppComponents.Button 
                                    height={ButtonHeight+'px'}
                                    className="return-button"
                                    onClick={this.goBack}
                                >{ (!!appState.merchantData && appState.merchantData !== '' 
                                    ? phrase_return(appState.merchantData)
                                    : term_return
                                )}</PrestoAppComponents.Button>
                            </div>
                        ) : null
                    )}

                    {showPoweredByPresto !== false && (
                        <PoweredByPresto/>   
                    )}
                </Container>

                { (!!showRedirectLink && !this.isMessage()) && (
                    <CancelLinkWrapper>
                        <span onClick={this.immediateCancelTransaction} className="link">{phrase_CancelTransactionAndReturn}</span>
                    </CancelLinkWrapper>
                )} 
                
                <Loader isShown={!!appState.isLoading} />            
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return ({
        appState: state.app.appState,
    })
};

const mapDispatchToProps = (dispatch) => ({
    setStopQueryPolling: (data) => dispatch(setStopQueryPolling(data)),
    setCurPageIsError: (data) => dispatch(setCurPageIsError(data)),
    userTriggeredLeave: (data) => dispatch(userTriggeredLeave(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageWrapper);

const Container = styled.div`
    position: relative;
    width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 2);
    max-width: ${ContainerWidth}px;
    min-height: ${props => (props.containerHeight ? props.containerHeight + 'px' : ContainerHeight +'px')};
    margin: calc(${ContainerOffsetTop}px - ${HeaderHeight}px) auto 0;
    box-shadow: ${PrestoAppTheme.layout.boxShadow};
    border-radius: ${PrestoAppTheme.layout.borderRadius};
    background-color: ${PrestoAppTheme.colors.white};
    font-size: ${PrestoAppTheme.layout.fontSizeSmall};
    overflow: hidden;
    @media only screen and (max-width: 320px) {
        width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 1);
    }

    & .action-area {
        padding: 0 ${PrestoAppTheme.layout.commonGap} ${PrestoAppTheme.layout.commonGap};
    }

    &.is-message {
        display: flex;
        flex-direction: column;

        & .action-area {
            margin-top: auto;
        }
    }
`;

const CancelLinkWrapper = styled.div`
    max-width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 2);
    box-shadow: ${PrestoAppTheme.layout.boxShadow};
    border-radius: 10px;
    background-color: ${PrestoAppTheme.colors.white};
    padding: ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.largeGap};
    margin: ${PrestoAppTheme.layout.smallGap} 0;
    text-align: center;
    opacity: 65%;

    & .link {
        font-weight: 400;
        font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        color: ${PrestoAppTheme.colors.baseBlue};
        cursor: pointer;
    }
`;

const LogoArea = styled.div`
    width: calc(100% - ${PrestoAppTheme.layout.commonGap} * 2);
    margin-bottom: ${PrestoAppTheme.layout.smallGap};
    text-align: center;

    & .logo-holder {
        height: 5rem;

        & .logo {
            display: block;
            height: 100%;
            width: 100%;
            background: center / contain no-repeat;
        }
    }
`;